import fp from 'lodash/fp'
import { combine, withCallbacks } from 'react-hooks-combine'

import InputComponent from './component'

export default combine({
  defaultProps: {
    value: '',
    type: 'text',
    onChange: fp.noop,
  },

  hooks: [
    withCallbacks(
      {
        onInternalKeyDown:
          (_state, { onPressEnter, onKeyDown, keyCode, ...event }) =>
          () => {
            const ENTER_KEY = 13

            if (onPressEnter && !onKeyDown && keyCode === ENTER_KEY) {
              onPressEnter({ onPressEnter, onKeyDown, keyCode, ...event })
            }

            if (onKeyDown) {
              onKeyDown({ onPressEnter, onKeyDown, keyCode, ...event })
            }
          },
      },
      []
    ),
  ],
})(InputComponent)
